import React, { useState, useEffect, useRef } from "react";
import { FaCheck } from "react-icons/fa";
import { RxCaretDown } from "react-icons/rx";
import useTitanApp from "../../hooks/useTitanApp";

const CustomSelectionDropdown = ({
  label,
  name,
  value,
  options,
  onChange,
  className = "",
}) => {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSelect = (val) => {
    onChange({ target: { name, value: val } });
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel =
    options.find((opt) => opt.value === value)?.label || "Select";

  return (
    <div className="custom-select-wrapper" ref={dropdownRef}>
      <label style={{ marginBottom: "15px" }}>{label}</label>
      <div
        className={`custom-select ${className}`.trim()}
        onClick={() => setIsOpen(!isOpen)}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen((prev) => !prev);
          }
        }}
      >
        <span>{selectedLabel}</span>
        <RxCaretDown size={18} color={darkMode ? "#bdbdbd" : "#7c7c7c"} />
      </div>

      {isOpen && (
        <ul className="dropdown">
          {options.map((option, idx) => (
            <li
              key={idx}
              className={`option ${
                value === option.value ? "selected" : ""
              }`.trim()}
              onClick={() => handleSelect(option.value)}
            >
              {value === option.value && <FaCheck className="check-icon" />}
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomSelectionDropdown;
